import { ActionDropdown } from 'components';

import { ReactElement } from 'react';

import { usePlanMeta, usePlanMutations } from '../state';
import { PlanResolution, planResolutions, PlanResponse } from '../types';

const config = {
  DAY: {
    label: 'Day',
    icon: 'calendar-day',
  },
  WEEK: {
    label: 'Week',
    icon: 'calendar-week',
  },
  MONTH: {
    label: 'Month',
    icon: 'calendar',
  },
} as const;

export function ResolutionButton(): ReactElement {
  const { plan_resolution } = usePlanMeta();
  const { runMutation, setPlan } = usePlanMutations();
  async function setResolution(plan_resolution: PlanResolution) {
    const res = await runMutation<PlanResponse>(
      { method: 'POST', url: `plan/resolution/`, body: { plan_resolution } },
      {
        optimistic: (current) => ({ ...current, plan_resolution }),
        onSuccess: setPlan,
      },
    );
    res.unwrap();
    // @TODO handle horizontal scroll
  }
  const { icon, label } = config[plan_resolution];
  return (
    <ActionDropdown
      size="sm"
      testId="toggle-resolution"
      icon={icon}
      variant="secondary"
      actions={planResolutions.map((resolution) => {
        const { label, icon } = config[resolution];
        const active = plan_resolution === resolution;
        return {
          action: resolution,
          button: {
            children: label,
            active,
            disabled: active,
            icon,
            onClick: () => setResolution(resolution),
          },
        };
      })}
    >
      {label}
    </ActionDropdown>
  );
}
